module.exports = __webpack_public_path__ + "d450ac903d37f67c96f224131cb19aee.svg";